import { jwtDecode } from "jwt-decode";
import { UserType } from "../../model/userType";

interface TokenPayload {
    nameid: string;
    Type: string;
    SolarProviderCompanyId?: string;
    country_code?: string;
    nbf: number;
    exp: number;
    iat: number;
    [key: string]: any;
  }

  export function getTransactionRefFromToken (token: string) {
    const decodedToken: any = jwtDecode(token);
    return decodedToken['transactionId'] ?? "";
  }

export function isProvider() {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    return decodedToken['Type'] === UserType.Provider;
}

export function isAdmin() {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    return decodedToken['Type'] === UserType.BPSAdmin;
}

export function isUtilAdmin() {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    return decodedToken['Type'] === UserType.Utility;
}


export function isCustomer() {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    return decodedToken['Type'] === UserType.Customer;
}

export function getUserType() : UserType | null {
    const token = sessionStorage.getItem('token');
    if (token === null) return null;

    const decodedToken: any = jwtDecode(token);
    return decodedToken['Type'];
}

export function isGuest() : boolean {
    const token = sessionStorage.getItem('token');
    
    return token === null;
};

export function GetUserType(token: string) {
   const decodedToken: any = jwtDecode(token);
   return decodedToken['Type'];
}

function normalizePermissions(raw: any): string[] {
    if (!raw) return [];
    return Array.isArray(raw) ? raw.map(String) : [String(raw)];
}

export function hasPermission(permission: number) {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    const permissions = normalizePermissions(decodedToken['permissions']);
    return permissions.includes(String(permission));
}

export function hasAllPermissions(permissionsToCheck: number[]) {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    const permissions = normalizePermissions(decodedToken['permissions']);
    return permissionsToCheck.every(p => permissions.includes(String(p)));
}

export function hasAnyPermission(permissionsToCheck: number[]) {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    const permissions = normalizePermissions(decodedToken['permissions']);
    return permissionsToCheck.some(p => permissions.includes(String(p)));
}

export const getSolarProviderCompanyId = (token: string): string | null => {
    try {
      if (!token) {
        return null;
      }
      
      const decoded = jwtDecode<TokenPayload>(token);
      return decoded.SolarProviderCompanyId ?? null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

export const getCurrentSolarProviderCompanyId = (): string | null => {
  const token = sessionStorage.getItem("token");
  return token ? getSolarProviderCompanyId(token) : null;
};

export const getCountryCodeFromToken = (token: string): string | null => {
    try {
      if (!token) {
        return null;
      }
      
      const decoded = jwtDecode<TokenPayload>(token);
      return decoded.country_code ?? null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

export const getCountryCode = (): string | null => {
  const token = sessionStorage.getItem("token");
  return token ? getCountryCodeFromToken(token) : null;
};

export const getUtilityIdFromToken = (token: string): string | null => {
	try {
		if (!token) {
			return null;
		}

		const decoded = jwtDecode<TokenPayload>(token);
		return (
			(decoded.UtilityId as string | undefined) ??
			(decoded.utilityId as string | undefined) ??
			(decoded.UtilityID as string | undefined) ??
			null
		);
	} catch (error) {
		console.error("Error decoding token:", error);
		return null;
	}
};

export const getCurrentUtilityId = (): string | null => {
	const token = sessionStorage.getItem("token");
	return token ? getUtilityIdFromToken(token) : null;
};

export const getUserIdFromToken = (token: string): string | null => {
	try {
		if (!token) {
			return null;
		}

		const decoded = jwtDecode<TokenPayload>(token);
		return decoded.nameid ?? null;
	} catch (error) {
		console.error("Error decoding token:", error);
		return null;
	}
};

/** Null while nobody is signed in. The `nameid` claim, the same one the Flutter app reads. */
export const getCurrentUserId = (): string | null => {
	const token = sessionStorage.getItem("token");
	return token ? getUserIdFromToken(token) : null;
};
